export default import.meta.ROLLDOWN_FILE_URL_k42g_qeKBN7iMlP8_gZLtA